<div class="crud-popup-container">
  <div class="crud-popup-header">
    <span class="ibc-body-text-large-bold">{{ crudPopupData.title }}</span>
    <div *ngIf="crudPopupData.code?.showCrudHeaderOptions">
      <app-svg-icon
        [list]="showPopupIcons"
        (iconClicked)="onIconClicked($event)"
        class="icon-section">
      </app-svg-icon>
    </div>
    <div *ngIf="crudPopupData.code?.showModalCloseOption">
      <app-svg-icon
        [iconName]="'close'"
        class="cursor"
        [isStaticSvg]="true"
        [isFrom]="'Popup'"
        (staticIconClicked)="closePopup()"></app-svg-icon>
    </div>
  </div>
  <div class="crud-popup-content">
    <div class="information-container" *ngIf="crudPopupData.code?.isForCreateBag || crudPopupData.code?.isForCreateManifest">
      <app-svg-icon [iconName]="'infoWarning'" [isStaticSvg]="true" class="cursor banner-info-icon"></app-svg-icon>
      <span class="ibc-body-text-regular pt-2" [innerHTML]="crudPopupData.code?.message"></span>
    </div>
    <ng-container
      *ngIf="crudPopupData.injectedComponent"
      #componentContainer></ng-container>
  </div>
  <div class="crud-popup-footer" *ngIf="crudPopupData.code?.isFooterRequired">
    <div class="button-container">
      <button
        *ngIf="
          crudPopupData.code?.isStatusCodeAdditionalOrPodDetails ||
          crudPopupData.code?.isForBulkBagging ||   
          crudPopupData.code?.isForBulkManifesting || 
          crudPopupData.code?.isForBulkMawb ||
          crudPopupData.code?.isForBagGateway ||
            crudPopupData.code?.isForBagScanInManifest ||
          crudPopupData.code?.isForCreateBag || crudPopupData.code?.isForCreateManifest ||
          crudPopupData.code?.isStatusCodeAttachmentDetails ||
          crudPopupData.code?.isForSendingInvoice || crudPopupData.code?.isBagScanShipment
        "
        class="ibc-medium-button ibc-secondary-default-button cursor"
        (click)="closePopup()">
        <span class="ibc-body-text-regular">{{ popupButtons.Cancel }}</span>
      </button>
      <button
        class="ibc-medium-button ibc-primary-default-button"
        [ngClass]="isConfirmButtonDisabled() ? '' : 'cursor'"
        [disabled]="isConfirmButtonDisabled()"
        (click)="handleConfirmAction(getScreenData())"
        *ngIf="!crudPopupData.code?.isForSendingInvoice">
        <span class="ibc-body-text-regular">{{ getScreenData() }}</span>
      </button>
    </div>
    <div
      class="pagination-container"
      *ngIf="crudPopupData.code?.isPaginationRequired">
      <mat-paginator
      #paginator
      class="ibc-table-pagination top-pagination"
      [length]="crudPopupData.code?.totalData"
      [pageIndex]="crudPopupData.code?.recordIndex"
      [pageSize]="1"
      (page)="onChangePage($event)"
      [hidePageSize]="true"
      [showFirstLastButtons]="false"
      [disabled]="hidePagination"></mat-paginator>
    </div>
  </div>
</div>
